// extracted by mini-css-extract-plugin
module.exports = {"container":"document-page_container__2l79l","main":"document-page_main__KZyOn","tabs":"document-page_tabs__3oF01","content":"document-page_content__ILLyc"};